'use es6';

import { QuestionTypes } from '../constants/QuizConstants';
import { List, Record } from 'immutable';
export default Record({
  answers: List(),
  correct: undefined,
  correctResponse: null,
  displayOrder: null,
  id: null,
  image: undefined,
  incorrectResponse: null,
  partiallyCorrectResponse: null,
  question: null,
  questionType: QuestionTypes.MULTIPLE_CHOICE_SELECT_ONE,
  quizId: null,
  language: null
}, 'Question');